const urlAdress = {
    email1: "/products/email-meeting-for-1-2-looks",
    email2: "/products/email-meeting-for-3-5-looks",
    email3: "/products/email-meeting-for-6-9-looks",
    zoom1: "/products/zoom-cloud-meetings-for-30-minutes",
    zoom2: "/products/zoom-cloud-meetings-for-90-minutes",
    zoom3: "/products/zoom-cloud-meetings-for-150-minutes",
    inp1: "/products/in-person-meetings-for-45-minutes",
    inp2: "/products/in-person-meetings-for-120-minutes",
    inp3: "/products/in-person-meetings-for-180-minutes"
};

const meetCosts = {
    email1: "50$",
    email2: "70$",
    email3: "100$",
    zoom1: "25$",
    zoom2: "85$",
    zoom3: "115$",
    inp1: "80$",
    inp2: "115$",
    inp3: "160$"
};

const formToSelect = {
    emailMeet: "emailFrequency",
    zoomMeet: "zoomAmount",
    inpMeet: "inPersonAmount"
}

function reRenderForm() {
    document.getElementById('emailMeet').setAttribute('style','display: none;');
    document.getElementById('zoomMeet').setAttribute('style','display: none;');
    document.getElementById('inpMeet').setAttribute('style','display: none;');
    const targetSelect = document.getElementById("desiredService").value;
    document.getElementById(targetSelect).setAttribute('style','display: block;');
    const selectForm = formToSelect[targetSelect];
    calculatePrice(selectForm);
}

function calculatePrice(targetedSelect) {
    const desiredResult = document.getElementById(targetedSelect).value;
    document.getElementById('totalPay').innerText = "TOTAL: " + meetCosts[desiredResult];
    document.getElementById('helperForm').setAttribute('action',urlAdress[desiredResult]);
}